import { BaseService } from "core/services";
import { TrackingCaseDocumentFieldValueRouteService } from "application/tracking-case/services";

class TrackingCaseDocumentFieldValueService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new TrackingCaseDocumentFieldValueRouteService());
    }
}

export default TrackingCaseDocumentFieldValueService;